import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 16,
	viewBox: "0 0 25 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15527_696)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M22.9142 0.336914H2.09176C1.22763 0.336914 0.524414 1.04803 0.524414 1.93078V14.0748C0.524414 14.9515 1.22763 15.6687 2.09176 15.6687H22.9142C23.7783 15.6687 24.4815 14.9576 24.4815 14.0748V1.92465C24.4755 1.04803 23.7783 0.336914 22.9142 0.336914Z",
			fill: "#2A2A6D"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11.9549 5.56629L10.9298 10.446H9.69028L10.7153 5.56629H11.9549ZM17.1813 8.71725L17.8369 6.8843L18.2123 8.71725H17.1813ZM18.5639 10.446H19.7141L18.7129 5.56629H17.6521C17.4138 5.56629 17.2111 5.70729 17.1217 5.92185L15.2624 10.446H16.5675L16.8297 9.71648H18.4209L18.5639 10.446ZM15.322 8.85825C15.3279 7.57089 13.5699 7.49733 13.5818 6.92108C13.5878 6.7433 13.7487 6.5594 14.1062 6.51035C14.285 6.48583 14.7737 6.46744 15.3279 6.73104L15.5484 5.69503C15.2505 5.58468 14.8631 5.48047 14.3863 5.48047C13.1587 5.48047 12.2946 6.14254 12.2886 7.09273C12.2826 7.79771 12.9084 8.19005 13.3732 8.423C13.8559 8.66208 14.0228 8.81533 14.0169 9.02989C14.0169 9.3548 13.6295 9.50192 13.2779 9.50805C12.6521 9.52032 12.2886 9.33641 12.0026 9.20154L11.7761 10.2682C12.0681 10.4031 12.6045 10.5195 13.1587 10.5257C14.4698 10.5318 15.322 9.87587 15.322 8.85825ZM10.1849 5.57242L8.17061 10.4521H6.85952L5.87025 6.5594C5.81066 6.32032 5.75702 6.23449 5.57824 6.13028C5.2743 5.96476 4.77967 5.8115 4.35059 5.71342L4.38038 5.57242H6.49004C6.75821 5.57242 7.00255 5.75633 7.06215 6.06897L7.58658 8.89503L8.87979 5.57242H10.1849Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15527_696",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 25,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgVisa;
